class WsmNativeMenu extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.items = Array.from(this.querySelector('.wn-menu').children);
    {
      this.items.forEach(item => {
        const heading = item.querySelector(':scope > .wn-target');
        const toggle = item.querySelector(':scope > .wn-toggle');
        if (toggle) {
          heading.setAttribute('aria-controls', toggle.getAttribute('aria-controls'));
          heading.setAttribute('aria-expanded', 'false');
        }
      });
    }
    this.addEventListener('click', event => {
      const heading = event.target.closest('.wn-level-0 > .wn-target');
      if (this.dataset.context === 'desktop' && heading?.matches('button')) {
        this.setOpen(heading.parentElement, !heading.parentElement.classList.contains('is-open'), 'click');
        return;
      }
      if (this.dataset.context === 'mobile' && heading && heading.parentElement.querySelector(':scope > .wn-toggle') && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
        const now = performance.now();
        const doubleTap = this.lastTap?.heading === heading && now - this.lastTap.time <= 350;
        clearTimeout(this.tapTimer);
        if (doubleTap) {
          this.lastTap = null;
          return;
        }
        event.preventDefault();
        this.lastTap = { heading, time: now };
        const open = () => {
          this.lastTap = null;
          this.setOpen(heading.parentElement, true, 'click');
        };
        if (event.detail === 0) open();
        else this.tapTimer = setTimeout(open, 350);
        return;
      }
      const toggle = event.target.closest('.wn-toggle');
      const back = event.target.closest('.wn-back');
      if (toggle) {
        this.clearTap();
        const item = toggle.parentElement;
        const open = item.dataset.openSource === 'pointer' || !item.classList.contains('is-open');
        this.setOpen(item, open, 'click');
      }
      if (back) {
        this.clearTap();
        const item = back.closest('.wn-level-0');
        this.setOpen(item, false);
        item.querySelector('.wn-toggle').focus();
      }
    }, options);
    this.addEventListener('keydown', event => {
      if (this.dataset.context === 'desktop' && event.key === 'ArrowDown' && event.target.matches('.wn-level-0 > .wn-target')) {
        event.preventDefault();
        this.setOpen(event.target.parentElement, true, 'keyboard');
        return;
      }
      if (event.key === 'Escape') {
        const open = this.items.find(item => item.classList.contains('is-open'));
        if (open) {
          event.preventDefault();
          event.stopPropagation();
          this.setOpen(open, false);
          open.querySelector(this.dataset.context === 'desktop' ? ':scope > .wn-target' : ':scope > .wn-toggle').focus();
        }
      }
    }, options);
    document.addEventListener('click', event => {
      if (!this.contains(event.target)) this.closeAll();
    }, options);
    this.drawer = this.closest('details.menu-drawer-container');
    this.drawer?.addEventListener('toggle', () => {
      if (!this.drawer.open) this.closeAll();
    }, options);
    window.addEventListener('resize', () => this.closeAll(), options);
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.clearTap();
    this.ready = false;
  }
  setOpen(item, open, source = '') {
    const toggle = item.querySelector(':scope > .wn-toggle');
    if (!toggle) { this.closeAll(); return; }
    if (open) this.items.filter(other => other !== item).forEach(other => this.setOpen(other, false));
    item.classList.toggle('is-open', open);
    item.dataset.openSource = open ? source : '';
    toggle.setAttribute('aria-expanded', String(open));
    item.querySelector(':scope > .wn-target').setAttribute('aria-expanded', String(open));
    const panel = item.querySelector(':scope > .wn-submenu');
    if (open) {
      panel.style.setProperty('--wn-panel-top', `${this.getBoundingClientRect().bottom}px`);
      panel.scrollTop = 0;
      this.refreshProducts(panel);
      if (this.dataset.context === 'mobile') panel.querySelector('.wn-back').focus();
    }
  }
  closeAll() {
    this.clearTap();
    this.items.filter(item => item.querySelector(':scope > .wn-toggle')).forEach(item => this.setOpen(item, false));
  }
  clearTap() {
    clearTimeout(this.tapTimer);
    this.lastTap = null;
  }
  async refreshProducts(panel) {
    const cards = Array.from(panel.querySelectorAll('[data-product-url]'));
    await Promise.all(cards.map(async card => {
      if (card.dataset.priceReady) return;
      try {
        const url = `${card.dataset.productUrl}.js`;
        if (!WsmNativeMenu.products.has(url)) {
          WsmNativeMenu.products.set(url, fetch(url, { credentials: 'same-origin' }).then(response => {
            if (!response.ok) throw new Error('Product unavailable');
            return response.json();
          }));
        }
        const product = await WsmNativeMenu.products.get(url);
        const variant = product.variants.reduce((lowest, next) => next.price < lowest.price ? next : lowest);
        const price = card.querySelector('.wn-price price-money');
        price.dataset.basePrice = String(variant.price / 100);
        price.setAttribute('data-taxable', String(variant.taxable));
        const oldPrice = card.querySelector('.wn-old-price price-money');
        if (oldPrice) {
          oldPrice.closest('.wn-old-price').hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
          oldPrice.dataset.basePrice = String((variant.compare_at_price || 0) / 100);
          oldPrice.setAttribute('data-taxable', String(variant.taxable));
        }
        card.dataset.priceReady = 'true';
      } catch {
        WsmNativeMenu.products.delete(`${card.dataset.productUrl}.js`);
      }
    }));
    if (cards.length && this.isConnected) {
      document.getElementById('vat-toggle-checkbox')?.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
WsmNativeMenu.products = new Map();
if (!customElements.get('wsm-native-menu')) customElements.define('wsm-native-menu', WsmNativeMenu);
